import {attr, Collection, define, IOPromise, Store} from "type-r";
import PermitsModel from "./PermitsModel";
import ProfileModel from "./ProfileModel";
import {localStorageIO} from "type-r/endpoints/localStorage"
import {baseURL} from "../config";
import TokenModel, {TokenCollection} from "./TokenModel";
import GroupModel from "./GroupModel";
import {appIO} from "./AuthEndpoint";
import UserModel from "./UserModel";
import StreetModel from "./StreetModel";

@define
class GlobalStore extends Store {
    @attr(TokenModel.Collection.has.endpoint(
        localStorageIO('deviceTokens')
    )) tokens: Collection<TokenModel>;
    @attr(String.has.watcher('onActiveTokenChange')) activeToken: string;
    @attr(PermitsModel) permits: PermitsModel;
    @attr(ProfileModel.has.endpoint(
        appIO(baseURL + 'my_profile')
    )) myProfile: ProfileModel;
    @attr(UserModel.Collection.has.endpoint(
        appIO(baseURL + 'pred/users/')
    )) users: Collection<UserModel>;
    @attr(GroupModel.Collection.has.endpoint(
        appIO(baseURL + 'my_groups/')
    )) myGroups: Collection<GroupModel>;
    @attr(0) dummy: number;
    @attr(StreetModel.Collection.has.endpoint(appIO(baseURL + 'pred/streets')))
    streets: Collection<StreetModel>;
    @attr(StreetModel.Collection.has.endpoint(appIO(baseURL + 'streets')))
    streetsRO: Collection<StreetModel>;

    get isAnonimous(): boolean {
        return !this.activeToken
    }

    startPromise: Promise<any>;

    start(): Promise<any> {
        if (!this.startPromise) {
            this.startPromise = this._start().then((results: any) => {
                this.startPromise = null;
                this.dummy++;
                return results;
            });
        }
        return this.startPromise;
    }

    private _start() {
        return (this.activeToken
            ? this._loadAll()
            : this.tokens.fetch().then(() => {
                const currentToken = (this.tokens as TokenCollection).getCurrent();
                if (currentToken) {
                    this.set({
                        activeToken: currentToken.token
                    });
                    return this._loadAll();
                }
                this.activeToken = null;
                this.trigger('no-auth');
                if (this.streetsRO.length > 0) {
                    return
                }
                return this.streetsRO.fetch();
            })).catch(error => {
            if (error.message.toLowerCase() === 'forbidden' || error.message === "Недопустимый токен.") {
                (this.tokens as TokenCollection).getCurrent().destroy();
                this.activeToken = null;
                this.trigger('no-auth');
                this.myGroups.reset([]);
                return;
            }
            console.error(error);
        });
    }

    private async _loadAll():Promise<any> {
        if(!this.myGroups.length) {
            await this.myGroups.fetch();
        }
        if (this.isChairman) {
            await Promise.all([this.loadUsers(), this.streets.fetch()]);
            return;
        }
        await this.loadMyProfile();
    }

    onActiveTokenChange(...args: any[]) {
        console.log('onActiveTokenChange', args);
        if (!this.activeToken) {
            return;
        }
        if (this.startPromise) {
            return this.startPromise.then(() => this.start());
        } else {
            return this.start();
        }

    }

    loadMyProfile(): IOPromise<any> {
        return this.myProfile.fetch().catch(error => {
            console.error(error);
        });
    }

    loadUsers(): IOPromise<any> {
        return this.users.fetch().catch(error => {
            console.error(error);
            if (error.message.toLowerCase() === 'forbidden') {
                return
            }
            throw error;
        });
    }

    logOut() {
        this.activeToken = null;
        const currentToken = (this.tokens as TokenCollection).getCurrent();
        if (currentToken) {
            currentToken.isCurrent = false;
            currentToken.save().then(() => {
                window.location.reload(true);
            });
        }
    }

    get isChairman() {
        return new Set(this.myGroups.map(x => x.name)).has("chairman")
    }

    get isStaff() {
        return new Set(this.myGroups.map(x => x.name)).has("staff")
    }
}

const globalStore = new GlobalStore();
window['globalStore'] = globalStore;
export {GlobalStore};
export default globalStore;


// WEBPACK FOOTER //
// ./src/models/globalStore.ts